// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SecurityScanTwoToneSvg from "@fishx/icons-svg/es/asn/SecurityScanTwoTone";
import FishxIcon from '../components/FishxIcon';

var SecurityScanTwoTone = function SecurityScanTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SecurityScanTwoToneSvg
  }));
};

SecurityScanTwoTone.displayName = 'SecurityScanTwoTone';
export default React.forwardRef(SecurityScanTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SecurityScanTwoTone.js
// module id = 4077
// module chunks = 0